<igx-grid #gridClientes [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [sortingOptions]="sortingOptions"
  [rowEditable]="true" [primaryKey]="'IdCliente'" (rowEditEnter)="rowEditEnter()" (rowEditExit)="rowEditExit()"
  (rowEditDone)="addUpdateCliente($event)" (rowEdit)="validarCliente($event)" (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()"
  [igxGridState]="optionsGridLocal" (keydown)="customKeydown($event)" (columnInit)="onColumnInit($event)" [moving]="true" paste-handler-neodata (onDataProcessed)="datosPegadosDesdeExcel($event)"
          (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[0, 1, 2, 3, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="Cliente" header="{{ 'GRIDS.CLIENTE.COL_CLIENTE' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
    <ng-template igxHeader #clienteHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CLIENTE.COL_CLIENTE' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #clienteEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="Cliente" [(ngModel)]="cell.editValue" uppercase [igxTextSelection]="true" [igxFocus]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="20"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="NombreCliente" header="{{ 'GRIDS.CLIENTE.COL_NOMBRE' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #nombreClienteHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CLIENTE.COL_NOMBRE' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #nombreClienteEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="NombreCliente" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="1000"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="DireccionCliente" header="{{ 'GRIDS.CLIENTE.COL_DIRECCION' | translate}}" [dataType]="'string'" width="220px" [sortable]="true" [resizable]="true">
    <ng-template igxCellEditor #direccionClienteEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="DireccionCliente" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="80"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="ColoniaCliente" header="{{ 'GRIDS.CLIENTE.COL_COLONIA' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #coloniaClienteHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CLIENTE.COL_COLONIA' | translate}}">{{column.header}}</div>
    </ng-template>
    <ng-template igxCellEditor #coloniaClienteEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="ColoniaCliente" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="30"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  @if (false) {
    <igx-column field="IdCiudadCliente" [disableHiding]="true" />
  }
  <igx-column field="DescripcionCiudadCliente" header="{{ 'GRIDS.CLIENTE.COL_CIUDAD' | translate}}" [dataType]="'string'" width="150px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #descripcionCiudadClienteHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CLIENTE.COL_CIUDAD' | translate}}">{{column.header}}</div>
    </ng-template>
    <ng-template igxCellEditor #desCiudadClienteEditorTemplate let-cell="cell">
      <igx-input-group>
        <input #inputDesCiudadCliente igxInput name="desCiudadCliente" type="text" [(ngModel)]="cell.editValue" uppercase [readOnly]="true"
               (keydown)="stopPropagationPegado($event)"/>
        <igx-suffix>
          <button title="{{ 'MENSAJES.GRALS.BUSCAR_REGISTRO_CATALOGO' | translate }}" igxButton="contained" (buttonClick)="onOpen(inputDesCiudadCliente, cell.row.data)">
            <igx-icon>search</igx-icon>
          </button>
        </igx-suffix>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="CodigoPostalCliente" header="{{ 'GRIDS.CLIENTE.COL_CP' | translate}}" [dataType]="'string'" width="140px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #cpEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="CodigoPostalCliente" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="6"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="TelefonoCliente" header="{{ 'GRIDS.CLIENTE.COL_TELEFONO' | translate}}" [dataType]="'string'" width="110px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #telefonoClienteEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="TelefonoCliente" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="30"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="MailCliente" header="Mail" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" >
    <ng-template igxCellEditor #mailClienteEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="MailCliente" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="100"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <!--Acciones Editar, Agregar y Borrar-->
  @if (showActionStrip) {
    <igx-action-strip #actionstrip>
      <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px" (buttonClick)="accionStripRowBtn(actionstrip.context, 1)">
        <igx-icon>add</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px" (buttonClick)='startEdit(actionstrip.context)'>
        <igx-icon>edit</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab" (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
        <igx-icon>delete</igx-icon>
      </button>
    </igx-action-strip>
  }
</igx-grid>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu" [size]="sizeMenu" [subMenusOpciones]="subMenusOpciones"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX" [y]="contextmenuY" />
}
